import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';


export const OverviewDetail = ({ hero, title, subtitle, actionButtons, otherActions }) => (
  <Grid columns={2}>
    <Grid.Row>
      <Grid.Column width={16}>
        <div style={{ display: 'flex', justifyContent: 'start', gap: 24 }}>
          {hero}
          <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {title}
              <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                {actionButtons}
                {otherActions}
              </div>
            </div>
            {subtitle}
          </div>
        </div>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

OverviewDetail.propTypes = {
  hero: PropTypes.node,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  actionButtons: PropTypes.node,
  otherActions: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCOverviewDetail.jsx